import React from 'react';
import { Col, Input, Row, Select, Slider, Form, Button, Tooltip } from "antd";
import i18n from "i18next";
import ColorPicker from "../../tools/common/ColorPicker.js";
import { useSelector } from "react-redux";

const ZonePropertiesPanel = ({ canvasRef, form, selectedItem }) => {
    const categories = useSelector((state) => state.properties.categories);

    const zone = selectedItem;
    const zoneText = selectedItem._objects[1]

    return (
        <Row>
            <Col span={24}>
                <h3>{i18n.t('mapeditor.tools.superposition')}</h3>
            </Col>
            <Col span={24} className="mb-2" style={{ display: 'flex' }}>
                <Tooltip title={i18n.t('mapeditor.actions.bring-forward')} placement="top">
                    <Button onClick={() => canvasRef.handler.bringForward()} className="btn-black sm mb-2 mr-2"><span className="icon-send-to-back"></span></Button>
                </Tooltip>
                <Tooltip title={i18n.t('mapeditor.actions.send-backwards')} placement="top">
                    <Button onClick={() => canvasRef.handler.sendBackwards()} className="btn-black sm mb-2 mr-2"><span className="icon-bring-to-front"></span></Button>
                </Tooltip>
                <Tooltip title={i18n.t('mapeditor.actions.bring-to-front')} placement="top">
                    <Button onClick={() => canvasRef.handler.bringToFront()} className="btn-black sm mb-2 mr-2"><span className="icon-bring-forward"></span></Button>
                </Tooltip>
                <Tooltip title={i18n.t('mapeditor.actions.send-to-back')} placement="top">
                    <Button onClick={() => canvasRef.handler.sendToBack()} className="btn-black sm mb-2"><span className="icon-send-backwards"></span></Button>
                </Tooltip>
            </Col>
            <Col span={24}>
                <h3>{i18n.t('propertyBar.zones.category')}</h3>
            </Col>
            <Col span={24}>
                <Form.Item label='Categoría' labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('category', { initialValue: zone.category.key })(
                        <Select >
                            <Select.Option key={0} value={0}>{'Seleccione categoría'}</Select.Option>
                            {categories.map(category => {
                                return (<Select.Option key={category.key} value={category.key}>{category.name}</Select.Option>)
                            })}
                        </Select>,
                    )}
                </Form.Item>
            </Col>
            <Col span={24}>
                <h3>{i18n.t('propertyBar.shapes.labelTitle')}</h3>
            </Col>
            <Col span={24} className="mb-2">
                <Form.Item label={"Nombre de la sección"}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('sectionLabel', {
                        initialValue: zone.section.label,
                        rules: [{
                            required: true,
                            message: i18n.t('validations.messageInput')
                        }],
                    })(<Input />)}
                </Form.Item>
                <Form.Item label={"Nombre mostrado"}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('displayedSectionLabel', {
                        initialValue: zone.section.displayedLabel,
                        rules: [{
                            message: i18n.t('validations.messageInput')
                        }],
                    })(<Input />)}
                </Form.Item>
                <Form.Item label={i18n.t('propertyBar.shapes.left')}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('leftText', {
                        initialValue: zoneText.left,
                    })(<Slider step={1} min={-100} max={100} />)}
                </Form.Item>
                <Form.Item label={i18n.t('propertyBar.shapes.top')}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('topText', {
                        initialValue: zoneText.top,
                    })(<Slider step={1} min={-100} max={100} />)}
                </Form.Item>
                <Form.Item label={i18n.t('propertyBar.shapes.fontSize')}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('fontSizeText', {
                        initialValue: zoneText.fontSize || '16',
                    })(
                        <Select>
                            {Array.from({ length: 48 }, (v, k) => (
                                <Select.Option key={k} value={`${k + 4}`}>
                                    {k + 4}
                                </Select.Option>
                            ))}
                        </Select>,
                    )}
                </Form.Item>
                <Form.Item label={i18n.t('propertyBar.shapes.fontColor')}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('fillText', {
                        initialValue: zoneText.fill || 'rgba(0, 0, 0, 1)',
                    })(<ColorPicker />)}
                </Form.Item>
                <Form.Item label={i18n.t('propertyBar.shapes.angle')}
                    labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                >
                    {form('angleText', {
                        initialValue: zoneText.angle
                    })(<Slider min={-180} max={180} />)}
                </Form.Item>
            </Col>
        </Row>
    );
}

export { ZonePropertiesPanel };
